import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "../design-system";
import { useAuth } from "../auth/AuthProvider";
import { useBranding } from "../branding/BrandingProvider";

const CUSTOMER_TABS = [
  { path: "/customer", label: "Home", icon: "⌂" },
  { path: "/customer/catalog", label: "Catalogo", icon: "☰" },
  { path: "/customer/cart", label: "Carrello", icon: "◱" },
  { path: "/customer/orders", label: "Ordini", icon: "◈" },
];

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const { branding } = useBranding();
  const nav = useNavigate();
  const loc = useLocation();
  const doLogout = async () => { await logout(); nav("/login"); };
  const isCustomer = user && (user.roles || []).includes("CUSTOMER") && !(user.roles || []).includes("ADMIN");

  return (
    <div className="app-shell">
      <header className="app-topbar">
        <Link to="/" className="app-brand" style={{ textDecoration: "none", color: "inherit" }}>
          {branding?.logo_compact_url
            ? <img src={branding.logo_compact_url} alt="" style={{ height: 30 }} />
            : <span className="app-brand-mark">B</span>}
          <span className="brand-name">{branding?.app_name || "Portale Ordini"}</span>
        </Link>
        {user && (
          <nav className="app-nav">
            <span className="muted user-label" style={{ fontSize: ".85rem" }}>
              {user.full_name || user.email} · <span className="kicker" style={{ letterSpacing: ".12em" }}>{(user.roles || []).join(", ")}</span>
            </span>
            <Button data-testid="logout-btn" variant="ghost" size="sm" onClick={doLogout}>Esci</Button>
          </nav>
        )}
      </header>
      <main className="app-main" style={isCustomer ? { paddingBottom: "5rem" } : {}}>{children}</main>
      {isCustomer && (
        <nav className="app-bottom-nav" data-testid="bottom-nav">
          {CUSTOMER_TABS.map((t) => {
            const active = loc.pathname === t.path || (t.path !== "/customer" && loc.pathname.startsWith(t.path));
            return (
              <Link key={t.path} to={t.path} className={`app-bottom-tab ${active ? "active" : ""}`} data-testid={`tab-${t.label.toLowerCase()}`}>
                <span className="app-bottom-icon">{t.icon}</span>
                <span className="app-bottom-label">{t.label}</span>
              </Link>
            );
          })}
        </nav>
      )}
    </div>
  );
}
